// export const convertHtmlToJson = (htmlString) => {
//   const parser = new DOMParser();
//   const doc = parser.parseFromString(htmlString, "text/html");

//   const result = {
//     counters: {
//       u_column: 0,
//       u_row: 0,
//       u_content_heading: 0,
//       u_content_text: 0,
//     },
//     body: {
//       id: generateId(),
//       rows: [],
//       headers: [],
//       footers: [],
//       values: {
//         backgroundColor: "#F7F8F9",
//         contentWidth: 700,
//         fontFamily: { label: "Arial", value: "arial,helvetica,sans-serif" },
//         textColor: "#000000",
//         _meta: { htmlID: "u_body", htmlClassNames: "u_body" },
//         linkStyle: {
//           body: true,
//           inherit: false,
//           linkColor: "#0012ee",
//           linkUnderline: true,
//           linkHoverColor: "#0000ee",
//           linkHoverUnderline: true,
//         },
//         backgroundImage: {
//           url: "",
//           fullWidth: true,
//           repeat: "no-repeat",
//           size: "custom",
//           position: "center",
//         },
//       },
//     },
//     schemaVersion: 21,
//   };

//   const rows = Array.from(doc.querySelectorAll(".u_row"));
//   result.counters.u_row = rows.length;

//   rows.forEach((row) => {
//     const rowId = generateId();
//     const rowObj = {
//       id: rowId,
//       cells: [],
//       columns: [],
//       values: {
//         padding: "0px",
//         backgroundColor: "",
//         columnsBackgroundColor: "",
//         backgroundImage: {
//           url: "",
//           fullWidth: true,
//           repeat: "no-repeat",
//           size: "custom",
//           position: "center",
//         },
//         _meta: {
//           htmlID: row.id || "",
//           htmlClassNames: "u_row",
//         },
//         selectable: true,
//         draggable: true,
//         duplicatable: true,
//         deletable: true,
//         hideable: true,
//         locked: false,
//       },
//     };

//     const columns = Array.from(row.querySelectorAll(".u_column"));
//     result.counters.u_column += columns.length;
//     rowObj.cells = columns.map(() => 1);

//     columns.forEach((col) => {
//       const colId = generateId();
//       const colObj = {
//         id: colId,
//         contents: [],
//         values: {
//           backgroundColor: "",
//           padding: "0px",
//           border: {},
//           borderRadius: "0px",
//           _meta: {
//             htmlID: col.id || "",
//             htmlClassNames: "u_column",
//           },
//           deletable: true,
//           locked: false,
//         },
//       };

//       // Content: Text
//       const textEl = col.querySelector(".u_content_text");
//       if (textEl) {
//         result.counters.u_content_text++;
//         colObj.contents.push({
//           id: generateId(),
//           type: "text",
//           values: {
//             containerPadding: "10px",
//             fontSize: "14px",
//             textAlign: "left",
//             lineHeight: "140%",
//             linkStyle: {
//               inherit: true,
//               linkColor: "#0000ee",
//               linkHoverColor: "#0000ee",
//               linkUnderline: true,
//               linkHoverUnderline: true,
//             },
//             _meta: {
//               htmlID: textEl.id || "",
//               htmlClassNames: "u_content_text",
//             },
//             text: textEl.innerHTML,
//             selectable: true,
//             draggable: true,
//             duplicatable: true,
//             deletable: true,
//             hideable: true,
//             locked: false,
//             hideDesktop: false,
//             displayCondition: null,
//             _styleGuide: null,
//             _languages: {},
//             anchor: "",
//           },
//         });
//       }

//       // Content: Heading
//       const headingEl = col.querySelector(".u_content_heading");
//       if (headingEl) {
//         result.counters.u_content_heading++;
//         const headingType =
//           headingEl.querySelector("h1,h2,h3,h4,h5,h6")?.tagName.toLowerCase() ||
//           "h1";
//         colObj.contents.push({
//           id: generateId(),
//           type: "heading",
//           values: {
//             containerPadding: "10px",
//             headingType: headingType,
//             fontSize: "22px",
//             textAlign: "left",
//             lineHeight: "140%",
//             linkStyle: {
//               inherit: true,
//               linkColor: "#0000ee",
//               linkHoverColor: "#0000ee",
//               linkUnderline: true,
//               linkHoverUnderline: true,
//             },
//             _meta: {
//               htmlID: headingEl.id || "",
//               htmlClassNames: "u_content_heading",
//             },
//             text: headingEl.innerHTML,
//             selectable: true,
//             draggable: true,
//             duplicatable: true,
//             deletable: true,
//             hideable: true,
//             locked: false,
//             hideDesktop: false,
//             displayCondition: null,
//             _styleGuide: null,
//             _languages: {},
//             anchor: "",
//           },
//         });
//       }

//       rowObj.columns.push(colObj);
//     });

//     result.body.rows.push(rowObj);
//   });

//   return result;

//   // Utility to generate pseudo-unique ID
//   function generateId() {
//     return Math.random().toString(36).substr(2, 10);
//   }
// };

const cheerio = require("cheerio");

export const convertHtmlToJson = (html) => {
  const $ = cheerio.load(html);
  const rows = $(".row");
  console.log(rows);
  //   const json = {
  //     counters: {
  //       u_column: 0,
  //       u_row: rows.length,
  //       u_content_heading: 0,
  //       u_content_text: 0,
  //       u_content_image: 0,
  //       u_content_html: 0,
  //       u_content_button: 0,
  //       u_content_social: 0,
  //       u_content_menu: 0,
  //     },
  //     body: {
  //       id: "generatedId",
  //       rows: [],
  //       headers: [],
  //       footers: [],
  //       values: {
  //         _meta: {
  //           htmlID: "u_body",
  //           htmlClassNames: "u_body",
  //         },
  //       },
  //     },
  //     schemaVersion: 21,
  //   };

  //   rows.each((rowIndex, rowElement) => {
  //     const row = {
  //       id: `row_${rowIndex + 1}`,
  //       cells: $(rowElement)
  //         .children()
  //         .map((_, cell) => 1)
  //         .get(),
  //       columns: [],
  //       values: {
  //         _meta: {
  //           htmlID: `u_row_${rowIndex + 1}`,
  //           htmlClassNames: "u_row",
  //         },
  //       },
  //     };

  //     const columns = $(rowElement).children();
  //     columns.each((colIndex, columnElement) => {
  //       const column = {
  //         id: `u_column_${colIndex + 1}`,
  //         contents: [],
  //         values: {
  //           _meta: {
  //             htmlID: `u_column_${colIndex + 1}`,
  //             htmlClassNames: "u_column",
  //           },
  //         },
  //       };

  //       // Process contents inside column
  //       $(columnElement)
  //         .children()
  //         .each((contentIndex, contentElement) => {
  //           if ($(contentElement).is("p")) {
  //             json.counters.u_content_text += 1;
  //             column.contents.push({
  //               id: `u_content_text_${json.counters.u_content_text}`,
  //               type: "text",
  //               values: {
  //                 containerPadding: "10px",
  //                 textAlign: "left",
  //                 fontSize: "14px",
  //                 lineHeight: "140%",
  //                 text: $(contentElement).text(),
  //               },
  //             });
  //           } else if ($(contentElement).is("h1")) {
  //             json.counters.u_content_heading += 1;
  //             column.contents.push({
  //               id: `u_content_heading_${json.counters.u_content_heading}`,
  //               type: "heading",
  //               values: {
  //                 containerPadding: "10px",
  //                 headingType: "h1",
  //                 textAlign: "left",
  //                 fontSize: "22px",
  //                 lineHeight: "140%",
  //                 text: $(contentElement).text(),
  //               },
  //             });
  //           } else if ($(contentElement).is("img")) {
  //             json.counters.u_content_image += 1;
  //             column.contents.push({
  //               id: `u_content_image_${json.counters.u_content_image}`,
  //               type: "image",
  //               values: {
  //                 containerPadding: "10px",
  //                 textAlign: "center",
  //                 src: {
  //                   url: $(contentElement).attr("src"),
  //                   width: $(contentElement).attr("width"),
  //                   height: $(contentElement).attr("height"),
  //                 },
  //                 altText: $(contentElement).attr("alt"),
  //               },
  //             });
  //           } else if ($(contentElement).is("a")) {
  //             json.counters.u_content_button += 1;
  //             column.contents.push({
  //               id: `u_content_button_${json.counters.u_content_button}`,
  //               type: "button",
  //               values: {
  //                 href: {
  //                   values: {
  //                     href: $(contentElement).attr("href"),
  //                     target: $(contentElement).attr("target"),
  //                   },
  //                 },
  //                 buttonColors: {
  //                   backgroundColor: "#3AAEE0",
  //                   color: "#FFFFFF",
  //                 },
  //                 size: { autoWidth: true, width: "100%" },
  //                 textAlign: "center",
  //                 fontSize: "14px",
  //                 lineHeight: "120%",
  //                 text: $(contentElement).html(),
  //               },
  //             });
  //           }
  //         });

  //       row.columns.push(column);
  //     });

  //     json.body.rows.push(row);
  //   });

  //   return json;
};
